module.exports = __webpack_public_path__ + "assets/ic_tree07.7cb09d1e.svg";